import { Grid, Link, Stack, SxProps, Theme } from '@mui/material'
import { IconButton } from 'components/Elements/Buttons/IconButton'
import { NicaIcon } from 'components/Elements/Buttons/NicaIcon'

export interface HeaderProps {
  sx?: SxProps<Theme>
}

export const Header: React.FC<HeaderProps> = ({ sx }) => {
  return (
    <Grid
      container
      justifyContent={{ xs: 'center', md: 'space-between' }}
      px={4}
      pt={4}
    >
      <Grid item xs={12} md={4} textAlign={{ xs: 'center', md: 'left' }}>
        <IconButton
          disableRipple
          sx={{ marginRight: 5, margin: 0 }}
          href="https://nica.com/"
        >
          <NicaIcon
            viewBox="0 0 331.34 207.57"
            sx={{ height: 90, width: 200 }}
          />
        </IconButton>
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
        alignContent="center"
        display={{ xs: 'none', md: 'block' }}
      >
        <Stack
          direction="column"
          justifyContent={{ xs: 'center', md: 'flex-start' }}
          alignItems={{ xs: 'center', md: 'flex-end' }}
          spacing={2}
        >
          <Grid item mt={{ xs: 2, md: 0 }}>
            <Link
              href="https://nica.com/contact/"
              sx={{
                color: 'black',
                textDecoration: 'none',
                fontFamily: 'Lato',
                pr: 2,
              }}
            >
              Contact Us
            </Link>
            <Link
              href="https://www.nica.com/medical-providers/#faq"
              sx={{
                color: 'black',
                textDecoration: 'none',
                fontFamily: 'Lato',
                pl: 2,
              }}
            >
              FAQ
            </Link>
          </Grid>
        </Stack>
      </Grid>
    </Grid>
  )
}
